import React from 'react'
import styles from '../../../../containers/Forms/Forms.css'

const NumInput = props => {
  const {
    input,
    meta: { touched, error, warning },
    label,
    getLabel,
    required,
    autoFocus,
    placeholder,
    disabled,
    inline,
    type = 'number',
    min,
  } = props

  const inputComponent = typeof getLabel === 'function'
    ? getLabel()
    : <span className={styles.label}>{label}</span>

  const cn = inline ? styles.inputRowGroup : styles.inputGroup

  return (
    <label
      className={cn}
      htmlFor={input.name}
    >
      {required &&
        <span className={styles.required} />
      }
      {inputComponent}
      <input
        {...input}
        autoComplete="off"
        className={styles.input}
        type={type}
        disabled={disabled}
        required={required}
        id={input.name}
        autoFocus={autoFocus}
        placeholder={placeholder}
        min={min}
      />
      {error && <span className={styles.error}>{error}</span>}
    </label>
  )
}

export default NumInput



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/components/NumInput/NumInput.jsx